import debug from 'debug'
import React from 'react'
import { Redirect, Route } from 'react-router'

interface IRedirectToLoginProps {
  useOrigin?: boolean
}

const log = debug('routing')

export const RedirectToLogin: React.SFC<IRedirectToLoginProps> = ({
  useOrigin = true,
}) => (
  <Route
    path="/login"
    children={({ match, location }) => {
      if (match) {
        return null
      }
      log('redirecting to login...')
      return (
        <Redirect
          to={{
            pathname: '/login',
            state: { origin: useOrigin ? location.pathname : '/' },
          }}
        />
      )
    }}
  />
)
